/**
 * Class for timing
 *
 * @class Stopwatch
 */
class Stopwatch {
  constructor() {
    this._start = null;
    this._end = null;
    this._elapsed = 0;
  }

  /**
   * Returns elapsed time
   *
   * @readonly
   */
  get time() {
    if (this._start == null) {
      return null;
    }

    if (this._end == null) {
      return Date.now() - this._start + this._elapsed;
    }

    return this._elapsed;
  }

  /**
   * Start the stopwatch
   *
   * @returns {Stopwatch}
   */
  start() {
    this._start = Date.now();
    this._end = null;

    return this;
  }

  /**
   * Stop (pause) the stopwatch
   *
   * @returns {Stopwatch}
   */
  stop() {
    this._end = Date.now();
    this._elapsed += this._end - this._start;

    return this;
  }

  /**
   * Reset the stopwatch
   *
   * @returns {Stopwathc}
   */
  reset() {
    this._start = null;
    this._end = null;
    this._elapsed = null;

    return this;
  }
}

export default Stopwatch;
